import React from 'react';
import { UseAppSelector } from '../../../store/hooks';

import * as styles from '../../../styles/flex/calculators/pageBanner.module.css';

function pageBanner() {
    // redux
    const statsEngine = UseAppSelector((state) => state.stats);
    const dataObject = statsEngine.find(item => item.title === 'business-data');
    const data = dataObject.data;

    const currentBusiness = data.find(item => item.title === 'current-reducer');

    return (
        <section className={styles.PageBanner}>
            <img src={currentBusiness.banner}/>
            <h2>{currentBusiness.reducer}</h2>

            <div className={styles.Triangle}>
                <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
                    <path d="M598.97 114.72L0 0 0 120 1200 120 1200 0 598.97 114.72z" className={styles.ShapeFill}></path>
                </svg>
            </div>
        </section>
    )
}

export default pageBanner
